import { render, staticRenderFns } from "./StorageSpaceIndex.vue?vue&type=template&id=7a9cc7ea&"
import script from "./StorageSpaceIndex.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports